export const COMMUNICATION_KEYS = {
  main: 'communication',
  settings: 'settings',
};

export const communicationQueryKeys = {
  getSettings: () => [COMMUNICATION_KEYS.main, COMMUNICATION_KEYS.settings],
};
